var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7 7.48457 6.81157 7.96914 6.4417 8.33603L1.89154 12.8494C1.68915 13.0502 1.35417 13.0502 1.15179 12.8494C0.949404 12.6487 0.949404 12.3164 1.15179 12.1157L5.70195 7.60225C6.03693 7.26997 6.03693 6.73003 5.70195 6.39775L1.15179 1.88434C0.949404 1.68359 0.949404 1.35131 1.15179 1.15056C1.35417 0.949813 1.68915 0.949813 1.89154 1.15056L6.4417 5.66397C6.81157 6.03086 7 6.51543 7 7Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.be01e18f8b16692ccb8d98300d6ce85f.svg";
export { ForwardRef as ReactComponent };